import { render } from "./SoundBarItem.vue?vue&type=template&id=25d108f7&scoped=true&lang=html"
import script from "./SoundBarItem.vue?vue&type=script&lang=js"
export * from "./SoundBarItem.vue?vue&type=script&lang=js"

import "./SoundBarItem.vue?vue&type=style&index=0&id=25d108f7&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-25d108f7"

export default script